module.exports = __webpack_public_path__ + "static/media/service-expanded.8dca5065.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pins/service-expanded.svg
// module id = 1949
// module chunks = 0